import { api } from "./api";

export const callApiSignin = async (data) => {
  return api.service("api/signin").create(data);
};

export const callApiSignup = async (data) => {
  return api.service("api/signup").create(data);
};

export const callApiWhiteLabelSignin = async (data) => {
  return api.service("api/signin").create(data);
};

export const callApiWhiteLabelSignup = async (data) => {
  return api.service("api/signup").create(data);
};

export const callApiBusinessSignup = async (data) => {
  return api.service("api/signup").create(data);
};

export const callApiUpdateUserPassword = async (userId, data) => {
  return api.service("api/signin").patch(userId, data);
};

export const callApiResetPassword = (data) => {
  return api.service("api/reset-password").create(data);
};

export const callApiUpdatePassword = (data) => {
  return api.service("api/update-password").create(data);
};
